module.exports = __webpack_public_path__ + "static/media/pivi.3f1fdb05.png";